import React from 'react';
import image from "../../assets/Unterschiede.jpg"
import {DelayedFrame} from "../DelayedFrame";
import {StimulusResponseFrame} from "../StimulusResponseFrame";
import {ResponseInput} from "../../MicroComponents/ResponseInput";
import {Form} from "../../Forms/Form";
import {MyTextArea} from "../../Forms/MyTextArea";
import {InstructionFrame} from "./InstructionFrame";

export function FolieUnterschiede(props) {
  return <DelayedFrame
    key={'constrast'}
    id={'contrast'}
    finish={props.finish}
    delay={60000}
  >
    <img src={image} alt={'Unterschiede beachten.'} style={{width: "110%"}}/>

  </DelayedFrame>
}

